import { getCustomerOnboardingIncompleteStepRoute } from "components/Screens/CustomerOnboarding/helpers";

import NavigationRoutes from "constants/NavigationRoutes";
import { USER_TYPES } from "constants";
import { consumeIntendedRoute, withCampaignParams } from "util/postLoginRedirect";

export const getUserInfoRequest = (loggedInUser) => {
  const { type, customerId, userId } = loggedInUser || {};
  if (type === "customer") {
    return `customer/${customerId}/info`;
  }
  if (type === "edge") {
    return `user/${userId}/summary`;
  }
  if (type === "employee") {
    return `employee/${userId}`;
  }
  return "";
};

export const handlePostLoginNavigation = (
  loggedInUser,
  additionalInfo,
  navigate,
  integratedContractSigning = false,
  { restoreIntendedRoute = true } = {}
) => {
  if (!loggedInUser || !loggedInUser.type) {
    return;
  }
  const { type, bankAttached } = loggedInUser;

  if (!Object.values(USER_TYPES).includes(type)) {
    return;
  }

  // Always consumed — never left stored — even when restoreIntendedRoute is false, so a
  // reset-password login can't leave a stale route sitting in the tab for the next sign-in.
  // Placed after the guards above: those two paths return without navigating, so consuming
  // there would destroy the saved route with no redirect to show for it.
  const consumedRoute = consumeIntendedRoute();
  const savedRoute = restoreIntendedRoute ? consumedRoute : null;

  if (type !== USER_TYPES.CUSTOMER) {
    navigate(withCampaignParams(savedRoute ?? NavigationRoutes.dashboard));
    return;
  }

  if (integratedContractSigning) {
    const { onboardingProgress = {} } = additionalInfo || {};
    const incompleteStepRoute = getCustomerOnboardingIncompleteStepRoute(onboardingProgress);

    if (incompleteStepRoute) {
      navigate(withCampaignParams(incompleteStepRoute));
      return;
    }
  }

  if (!bankAttached && additionalInfo?.status === "enabled") {
    navigate(withCampaignParams(NavigationRoutes.addPaymentMethod));
    return;
  }

  navigate(withCampaignParams(savedRoute ?? NavigationRoutes.dashboard));
};

export const getAuthenticationError = (errorList) => {
  if (errorList != null && errorList != undefined) {
    return errorList.map((error) => (
      <div key={error?.msg || error?.description || Math.random()} className="para-body-m-regular">
        {error?.msg || error?.description || "Something went wrong"}
      </div>
    ));
  }
  return null;
};
